export enum StoreTypes {
  appStore = 1,
  playStore = 2,
}

export const getMobileStoreType = (): StoreTypes | null => {
  const { userAgent } = navigator;

  if (/android/i.test(userAgent)) {
    return StoreTypes.playStore;
  }

  if (/iPhone/.test(userAgent)) {
    return StoreTypes.appStore;
  }

  return null;
};

// GOOGLE PLAY HANDS THE referrer VALUE TO THE APP AFTER INSTALL (INSTALL REFERRER)
export const buildPlayStoreUrl = (storeUrl: string, handoffQuery: string) => {
  if (!handoffQuery) return storeUrl;

  const separator = storeUrl.includes('?') ? '&' : '?';

  return `${storeUrl}${separator}referrer=${encodeURIComponent(handoffQuery)}`;
};
